import React, { createContext, useState, useEffect } from 'react';
import { onError } from '@apollo/client/link/error';
import toast, { Toaster } from 'react-hot-toast';
import { elGray, elRed } from '../styles/colors';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';

const standard = {
  backgroundColor: elRed,
  color: '#fff',
  marginTop: '50px',
  borderRadius: '5px',
  padding: '10px',
  border: '1px solid black',
  display: 'flex',
  fontWeight: 900,
  fontSize: '16px',
  width: 'fit-content',
}

const CustomToast = styled(View)`
  display: flex;
  flex-direction: row;
  width: 100%
  justify-content: space-between;

`;

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [currentToastId, setCurrentToastId] = useState('');

  const notify = (message, variant) => {
    setCurrentToastId(
      toast(
        getToast(message),
        {
          duration: 999999,
          style: variant
        },
      )
    );
  }

  const dismiss = () => {
    toast.dismiss(currentToastId);
  }

  const value = {
    notify,
    standard
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );

  function getToast(message) {
    return (
      <CustomToast>
        {message}
        <Pressable
          onPress={() => toast.dismiss()}
        >
          <FontAwesomeIcon
            icon={faSquareXmark}
            size={'18px'}
            style={{color: "#fff"}}
          />
        </Pressable>
      </CustomToast>
    )
  }
};

export default ToastContext;